/** Normalize assistant-visible content before it reaches the feed/renderers. */

const LEADING_TOOL_TAGS =
  /^[\s]*(?:<\/tool_calls>|<\/function_calls>|<\/tool_function_calls>|<\/antml_\w+>|<tool_calls>|<function_calls>|<tool_function_calls>)+[\s]*/g;
const TOOL_LEAK_BLOCK =
  /(?:^|\n)(?:#{1,6}\s*)?(?:emit_artifact|respond|refactor_apex|retrieve_apex)\s*\n?[\s\S]*?"tool"\s*:\s*"(?:emit_artifact|respond|refactor_apex|retrieve_apex)"[\s\S]*?(?=\n\n|\Z)/gi;
const ANYTHINGLLM_WRAPPER =
  /<anythingllm-function-(?:call|result)>[\s\S]*?(?:<\/anythingllm-function-(?:call|result)>|$)/gi;
const INTERNAL_LINE = /^\[INTERNAL\][^\n]*(?:\n|$)/gm;

export function normalizeAssistantContent(content: string): string {
  if (typeof content !== "string" || !content.trim()) return content || "";

  let normalized = content;
  const stripped = content.trim();
  if (stripped.startsWith("{") && stripped.endsWith("}")) {
    try {
      const parsed = JSON.parse(stripped);
      if (
        parsed &&
        typeof parsed === "object" &&
        "result" in parsed &&
        ("success" in parsed || "tool" in parsed || "server" in parsed)
      ) {
        const result = (parsed as { result?: unknown }).result;
        if (typeof result === "string" && result.trim()) {
          normalized = result;
        } else if (result != null) {
          normalized = JSON.stringify(result, null, 2);
        }
      }
    } catch {
      return content.replace(LEADING_TOOL_TAGS, "");
    }
  }

  return normalized
    .replace(LEADING_TOOL_TAGS, "")
    .replace(ANYTHINGLLM_WRAPPER, "\n")
    .replace(TOOL_LEAK_BLOCK, "\n")
    .replace(INTERNAL_LINE, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

// Per-chunk variant for streaming. Skips .trim() because trimming each
// token-sized chunk eats the leading space of " your" → "your", causing
// adjacent chunks to concatenate as "scanyourorg". The full assembled
// content is re-normalized at render time, so outer whitespace is still
// trimmed at the display boundary.
export function normalizeStreamingDelta(content: string): string {
  if (typeof content !== "string" || !content) return content || "";
  return content
    .replace(LEADING_TOOL_TAGS, "")
    .replace(ANYTHINGLLM_WRAPPER, "\n")
    .replace(TOOL_LEAK_BLOCK, "\n")
    .replace(INTERNAL_LINE, "")
    .replace(/\n{3,}/g, "\n\n");
}
